import TabelaItensComp from './TabelaItensComp'
export default TabelaItensComp



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/TabelaItensCustomForm/index.js